import Aux from './hoc/Auxiliary';
import ModWebParts from './containers/ModWebParts';
import React from "react";
import ReactDOM from "react-dom";

//main container component
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentWillMount() {
       
    }
    
    render() {
        return <ModWebParts webPartProperties={this.props.webPartProperties} />
    }
}
export default App;
 